export default "__VITE_ASSET__CyIEovnw__"